<template>
  <div class="cleaner">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>保洁员管理</span>
        <div class="header-buttons">
          <el-button type="primary" @click="showAddDialog" icon="el-icon-plus">添加</el-button>
          <el-button type="success" @click="refreshList" icon="el-icon-refresh">刷新</el-button>
        </div>
      </div>

      <!-- 筛选条件 -->
      <div class="filter-section" style="margin-bottom: 20px;">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-select
                v-model="filterSchoolId"
                placeholder="选择学校筛选"
                clearable
                style="width: 100%;"
                @change="filterBySchool"
            >
              <el-option label="全部学校" value=""></el-option>
              <el-option
                  v-for="item in schoolList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              />
            </el-select>
          </el-col>
        </el-row>
      </div>

      <!-- 保洁员列表 -->
      <el-table :data="filteredCleanerList" style="width: 100%;" v-loading="tableLoading">
        <el-table-column label="所属学校" min-width="120">
          <template slot-scope="scope">
            <el-tag v-for="(name, idx) in scope.row.school_names" :key="idx" style="margin-right:4px;">{{ name }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="保洁员姓名" min-width="120"/>
        <el-table-column prop="phone" label="手机号码" min-width="150"/>
        <el-table-column prop="created_at" label="创建时间" width="180" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="info" @click="viewCleanerRecords(scope.row.name)">
              查看记录
            </el-button>
            <el-button size="mini" type="danger" @click="deleteCleaner(scope.row.id)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 添加保洁员弹窗 -->
    <el-dialog title="添加保洁员" :visible.sync="addDialogVisible" width="500px" @close="resetForm">
      <el-form :model="form" :rules="rules" ref="cleanerForm" label-width="100px">
        <el-form-item label="所属学校" prop="school_ids">
          <el-select v-model="form.school_ids" multiple placeholder="请选择学校" style="width: 100%;">
            <el-option v-for="item in schoolList" :key="item.id" :label="item.name" :value="item.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="保洁员姓名" prop="name">
          <el-input v-model="form.name" placeholder="请输入保洁员姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="addCleaner" :loading="loading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Cleaner',
  data() {
    return {
      loading: false,
      tableLoading: false,
      addDialogVisible: false,

      // 保洁员表单
      form: {
        school_ids: [],
        name: '',
        phone: ''
      },
      rules: {
        school_ids: [
          {required: true, message: '请选择所属学校', trigger: 'change'}
        ],
        name: [
          {required: true, message: '请输入保洁员姓名', trigger: 'blur'},
          {min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur'}
        ],
        phone: [
          {required: true, message: '请输入手机号码', trigger: 'blur'},
          {pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur'}
        ]
      },

      // 数据列表
      schoolList: [],
      cleanerList: [],
      filteredCleanerList: [],

      // 筛选条件
      filterSchoolId: '',
      userRole: window.sessionStorage.getItem('userRole')
    }
  },
  created() {
    this.getSchoolList()
    this.getCleanerList()
  },
  methods: {
    // 显示添加弹窗
    showAddDialog() {
      this.addDialogVisible = true
    },
    // 刷新列表
    refreshList() {
      this.getCleanerList()
    },
    // 获取学校列表
    async getSchoolList() {
      try {
        const {data: res} = await this.$http.get('/api/school/list')
        if (res.status !== 0) return this.$message.error('获取学校列表失败')
        this.schoolList = res.data
      } catch (error) {
        this.$message.error('获取学校列表失败')
      }
    },
    // 添加保洁员
    addCleaner() {
      this.$refs.cleanerForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          try {
            const {data: res} = await this.$http.post('/api/cleaner/add', this.form)
            if (res.status !== 0) return this.$message.error('添加失败，手机号可能已存在')
            this.$message.success('添加成功')
            this.addDialogVisible = false
            this.resetForm()
            this.getCleanerList()
          } catch (error) {
            this.$message.error('添加失败，手机号可能已存在')
          } finally {
            this.loading = false
          }
        }
      })
    },

    // 获取保洁员列表
    async getCleanerList() {
      this.tableLoading = true
      try {
        const {data: res} = await this.$http.get('/api/cleaner/list')
        if (res.status !== 0) return this.$message.error('获取保洁员列表失败')
        this.cleanerList = res.data
        this.applyFilter()
      } catch (error) {
        this.$message.error('获取保洁员列表失败')
      } finally {
        this.tableLoading = false
      }
    },

    // 按学校筛选
    filterBySchool() {
      this.applyFilter()
    },

    // 应用筛选条件
    applyFilter() {
      // 如果是学校管理者，不需要筛选，因为后端已经限制了数据
      if (this.userRole === 'school_manager') {
        this.filteredCleanerList = [...this.cleanerList]
        return
      }
      if (!this.filterSchoolId) {
        // 不筛选，显示全部
        this.filteredCleanerList = [...this.cleanerList]
      } else {
        // 按学校筛选
        this.filteredCleanerList = this.cleanerList.filter(item =>
            item.school_ids && item.school_ids.includes(Number(this.filterSchoolId))
        )
      }
    },

    // 删除保洁员
    deleteCleaner(id) {
      this.$confirm('此操作将永久删除该保洁员及其相关记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const {data: res} = await this.$http.delete(`/api/cleaner/delete/${id}`)
          if (res.status !== 0) return this.$message.error('删除失败')
          this.$message.success('删除成功')
          this.getCleanerList()
        } catch (error) {
          this.$message.error('删除失败')
        }
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },

    // 重置表单
    resetForm() {
      this.$refs.cleanerForm.resetFields()
    },

    // 查看保洁员记录
    viewCleanerRecords(cleanerName) {
      this.$router.push({
        path: '/inspectionmanage',
        query: {cleaner_name: cleanerName}
      })

      // 手动更新菜单状态
      this.$nextTick(() => {
        window.sessionStorage.setItem('activePath', '/inspectionmanage')
      })
    },

    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped>
.cleaner {
  padding: 20px;
}

.box-card {
  margin-bottom: 20px;
}

.header-buttons {
  float: right;
}

.header-buttons .el-button {
  margin-left: 10px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>